export const MAIN_CARD_STATIC_TITLE = 'MAIN_CARD_STATIC_TITLE';
export const MAIN_CARD_STATIC_FIRST = 'MAIN_CARD_STATIC_FIRST';


// WEBPACK FOOTER //
// ./src/translations/constants.js